import { render, staticRenderFns } from "./skill-model.vue?vue&type=template&id=7c0d320c"
import script from "./skill-model.vue?vue&type=script&lang=js"
export * from "./skill-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports